/**
 * Appends or sets showIntercomButton=false on the given URL.
 * @param {string} url - Full URL string
 * @returns {string} URL with showIntercomButton=true in the query string
 */
export default function addHideIntercomButtonToUrl(url) {
  const parsed = new URL(url);
  parsed.searchParams.set("showIntercomButton", "false");
  return parsed.toString();
}
